/**
 * City catalog.
 *
 * The product launches with Shanghai only, but every city-scoped query and
 * every stored coordinate already flows through this catalog, so adding a city
 * is a data change rather than a code change.
 */

export const CITY_KEYS = ['shanghai'] as const

export type CityKey = (typeof CITY_KEYS)[number]

export interface CityDefinition {
  key: CityKey
  /** AMap administrative code, used as the `city` parameter of POI search. */
  adcode: string
  /** IANA time zone of the city, used for calendar rendering. */
  timeZone: string
  /** GCJ-02 city centre. */
  center: { lat: number; lng: number }
  labelKey: string
}

export const CITIES: Record<CityKey, CityDefinition> = {
  shanghai: {
    key: 'shanghai',
    adcode: '310000',
    timeZone: 'Asia/Shanghai',
    center: { lat: 31.2304, lng: 121.4737 },
    labelKey: 'city.shanghai',
  },
}

export function isCityKey(value: string): value is CityKey {
  return (CITY_KEYS as readonly string[]).includes(value)
}

export function resolveCity(value: string | null | undefined, fallback: CityKey): CityDefinition {
  if (value && isCityKey(value)) {
    return CITIES[value]
  }
  return CITIES[fallback]
}
